import { render } from "./MenuPlay.vue?vue&type=template&id=63fbffd0"
import script from "./MenuPlay.vue?vue&type=script&lang=js"
export * from "./MenuPlay.vue?vue&type=script&lang=js"
script.render = render

export default script